export default __webpack_public_path__ + "static/media/skills-light.d165219b.svg";